import { render } from "./video-recommend.vue?vue&type=template&id=dc71dbd6&scoped=true"
import script from "./video-recommend.vue?vue&type=script&lang=js"
export * from "./video-recommend.vue?vue&type=script&lang=js"

import "./video-recommend.vue?vue&type=style&index=0&id=dc71dbd6&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\ahuview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc71dbd6"]])

export default __exports__